import { useContext, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShopContext } from '../context/ShopContext';
import SingleProductGallery from '../components/SingleProductGallery';
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FiYoutube } from "react-icons/fi";
import { CiClock2 } from "react-icons/ci";
import SubCategoryPrdouctItem from '../components/SubCategoryPrdouctItem';
import Title from '../components/Title';
import RelatedProduct from '../components/RelatedProduct';
import GalleryContribution from '../components/GalleryContribution';
import axiosInstance from '../api/axiosInstance';

const Product = () => {
  const { productId } = useParams(); // Get the product ID from the URL
  const { currency } = useContext(ShopContext); // Get products from context
  const [productData, setProductData] = useState(null); // State to hold the product data

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await axiosInstance.get(`/campaign/${productId}`);
        if (response.data.success) {
          setProductData(response.data.data);
        } else {
          console.warn('API call succeeded, but returned unsuccessful status');
        }
      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    };

    fetchProductData();
  }, [productId]);

  if (!productData) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="product-page">
      {/* Single Product Gallery Section */}
      <SingleProductGallery images={productData.thumbnail_imge} />

      <div className="banner_card pb-5">
        <div className="container">
          <div className="custom_card m-0">
            <div className="mb-3 d-md-flex align-items-center justify-content-between text-md-start">
              <div className="mb-3 mb-md-0">
                <h4>{productData.name}</h4>
              </div>
              <div className="benefit_tag mb-3 mb-xl-0 text-md-end">
                <span>{productData.isTaxBenefit ? 'Tax Benefit' : ''}</span>
              </div>
            </div>
            <div className="d-md-flex common-flex-s align-items-center justify-content-between mb-3 text-center text-md-start">
              <div className="price">{currency}5</div>
              <div className="price"><span className="text-primary"> 50</span> Donated</div>
            </div>

            <div className="progress my-2 p-0">
              <div className="progress progress-bar bg-danger" style={{ width: `${(5 / 50) * 100}%` }}>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="donars">
                <i className="fa fa-users"></i>
                {10} + Donors
              </div>
              <div className="hour">
                <CiClock2 />
                {11} hours left
              </div>
            </div>
            <div className="d-md-flex align-items-center justify-content-between">
              <div className="desc mb-3 mb-md-0">
                <strong>Share this fundraiser</strong> <br />
                Every Social Media Share Brings Rs 5000
              </div>
              <div className="social_link">
                <ul className="d-flex align-items-center">
                  <li><Link to=""><FaFacebookF /></Link></li>
                  <li><Link to=""><FaXTwitter /></Link></li>
                  <li><Link to=""><FaInstagram /></Link></li>
                  <li><Link to=""><FiYoutube /></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="product_sec pb-5">
        <div className="container">
          <div className="section_title mb-5">
            <h4>Products</h4>
          </div>
          <SubCategoryPrdouctItem productAbout={productData.project} campaignProduct={productData.campaign_product} />
          <GalleryContribution contributionImages={productData.gallery_image} />
          <Title text1={'Similar Campaigns'} />
          <RelatedProduct />
        </div>
      </div>
    </div>
  );
}

export default Product;
